<template>
    <div class="kimsa-textarea">
        <span v-if="label" :class="['label', {'bolder': bolderLabel}]">{{ label }}</span>
        <v-textarea
            :autofocus="autofocus"
            :color="color"
            :value="model"
            @input="onChange"
            @click:clear="model = ''"
            :placeholder="placeholder"
            :rules="rules"
            :clearable="clearable"
            :inputmode="inputMode"
            :rows="rows"
            hide-details
            solo
            flat
            :class="[{'kimsa-elevation': !noElevation}]"
        ></v-textarea>
    </div>

</template>

<script>
export default {
    name: "KimsaTextareaField",
    props: {
        autofocus: {
            type: Boolean,
            default: false
        },
        inputMode: {
            type: String,
            default: 'text'
        },
        clearable: {
            type: Boolean,
            default: false
        },
        label: {
            type: String,
            default: '',
        },
        color: {
            type: String,
            default: 'secondary'
        },
        rules: {
            type: Array,
            default: () => []
        },
        placeholder: {
            type: String,
            default: ''
        },
        value: {
            type: String,
            default: '',
        },
        outlined: {
            type: Boolean,
            default: false
        },
        noElevation: {
            type: Boolean,
            default: false,
        },
        rows: {
            type: [Number, String],
            default: 3
        },
        bolderLabel: {
            type: Boolean,
            default: false
        },
        forceValue: {
            type: Boolean,
            default: false
        },
    },
    data() {
        return {
            model: '',
        }
    },
    methods: {
        focus() {
            const vm = this
            vm.$refs['baseInput'].focus()
        },
        onChange(value) {
            const vm = this
            if (!value) return vm.model = ''
            return vm.model = value
        },
        setDefaults() {
            const vm = this
            if (vm.value || vm.forceValue) {
                vm.model = vm.value
            }
        }
    },
    mounted() {
        const vm = this
        vm.setDefaults()
    },
    watch: {
        value() {
            this.setDefaults()
        },
        model(val) {
            this.$emit('change', val)
        }
    }
}
</script>

<style scoped>

.label {
    display: block;
    font-size: var(--fs-label);
    font-weight: 500;
    color: var(--v-txtSecondary-base);
    margin-bottom: 6px;
}

.bolder {
    font-weight: 700;
}

.kimsa-textarea ::v-deep .v-input__slot {
    border-radius: 8px;
    align-items: flex-start;
}

.kimsa-textarea ::v-deep textarea {
    resize: vertical;
    line-height: 1.5;
    font-size: var(--fs-input);
}

</style>